<template>
    <div>
        <h3>微信消息推送</h3>
        <el-form size="mini" class="w640" label-width="180px">
            <el-form-item label="openid">
                <el-input type="textarea" :rows="10" v-model="openIds" placeholder="openid"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="pushMsg" size="mini">推送</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-card v-if="openIdArr.length" class="box-card w640" shadow="never">
            <p>此次共推送 {{openIdArr.length}} 个用户，成功 {{successNum}} 个</p>
            <div v-for="openId,index in openIdArr" :key="index" class="text item">
                {{ openId }}
            </div>
        </el-card>
    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'

const {
    wx,
} = api

export default {
    name: 'wxPush',
    data() {
        return {
            map,
            openIds: '',
            successNum: 0,
            isSubmiting: false,
            openIdArr: [],
        }
    },
    components: {},
    computed: {},
    watch: {},
    methods: {
        async pushMsg() {

            if (this.openIds) {
                if (this.isSubmiting) return false;
                this.isSubmiting = true;
                let obj = {
                    openIds: this.openIds
                }
                let {
                    data: {
                        code,
                        data,
                    }
                } = await wx.push(obj)
                if (code == 200 && data > 0) {
                    this.successNum = data
                    this.$message.success('消息推送成功！')
                    this.openIds = '';
                } else {
                    this.successNum = 0
                    this.$message.error('消息推送失败!')
                }
                this.openIdArr = this.openIds.split('#');
                this.isSubmiting = false

            } else {
                this.$message.error('openid不能为空！')
            }

        },
    },
    mounted() {},
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/wx/push.vue